import { FieldType, FormControlModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { Category, Channel, Subject } from './vorwerk-metadata-config';

/**
 * Vorwerk general information forms
 * @returns
 */
export const vorwerkGeneralInformationFields = (): FormControlModel[] => [
  {
    formTypeId: '1',
    formFieldName: 'name',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Asset name`,
    placeholder: $localize`:placeholder:Asset name`,
    inputType: 'text',
    disable: true,
    validators: {
      required: true,
    },
    widthClass: WidthClass.WFull,
    value: '',
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'status',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Status`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    options: [],
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'publishStartDate',
    fieldType: FieldType.Date,
    fieldLabel: $localize`Published from`,
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    widthClass: WidthClass.W14,
    value: '',
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'publishEndDate',
    fieldType: FieldType.Date,
    fieldLabel: $localize`Published until`,
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    widthClass: WidthClass.W14,
    value: '',
    visible: true,
  },
  {
    formTypeId: '5',
    formFieldName: 'domains',
    fieldType: FieldType.FormArray,
    fieldLabel: $localize`Domains`,
    hideLabel: true,
    widthClass: WidthClass.WFull,
    visible: true,
    formFieldGroup: [
      {
        formTypeId: '5_1',
        formFieldName: 'agency',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Domain`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        repeatFieldLabel: true,
        validators: {
          required: true,
        },
        value: undefined,
        disableSingleSelect: true,
        dropDownSearch: true,
        options: [],
        visible: true,
      },
      {
        formTypeId: '5_2',
        formFieldName: 'client',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Location`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        validators: {
          required: true,
        },
        value: undefined,
        disableSingleSelect: true,
        dropDownSearch: true,
        options: [],
        visible: true,
        nestedOptions: {},
      },
      {
        formTypeId: '5_3',
        formFieldName: 'brand',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Brand`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        validators: {
          required: true,
        },
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: true,
        nestedOptions: {},
      },
      {
        formTypeId: '5_4',
        formFieldName: 'category',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Category`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        value: undefined,
        disableSingleSelect: true,
        dropDownSearch: true,
        options: Category,
        visible: false,
        nestedOptions: {},
      },
      {
        formTypeId: '5_5',
        formFieldName: 'product',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Product`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: false,
        nestedOptions: {},
      },
      {
        formTypeId: '5_6',
        formFieldName: 'subcategory',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Sub category`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: false,
        nestedOptions: {},
      },
    ],
  },
  {
    formTypeId: '9',
    formFieldName: 'description',
    fieldType: FieldType.Textarea,
    fieldLabel: $localize`Description`,
    placeholder: $localize`Description`,
    inputType: 'text',
    widthClass: WidthClass.WFull,
    value: '',
    visible: true,
  },
  {
    formTypeId: '10',
    formFieldName: 'plannedDeletionToggle',
    fieldType: FieldType.Checkbox,
    fieldLabel: $localize`Planned for deletion`,
    placeholder: '',
    widthClass: WidthClass.W13,
    editOnly: true,
    value: '',
    visible: true,
  },
  {
    formTypeId: '11',
    formFieldName: 'plannedDeletion',
    fieldType: FieldType.Date,
    fieldLabel: $localize`Deletion date`,
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    widthClass: WidthClass.W13,
    value: '',
    editOnly: true,
    disable: true,
    validators: {
      required: true,
    },
    visible: true,
  },
];

/**
 * Vorwerk general information forms
 * @returns
 */
export const vorwerkTaggingNTaxonomyFields = (): FormControlModel[] => [
  {
    formTypeId: '4',
    formFieldName: 'channel',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Channel`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    dropDownSearch: true,
    options: Channel,
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'subject',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Subject`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    dropDownSearch: true,
    options: Subject,
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'exchange_link',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Exchange Link`,
    placeholder: $localize`:placeholder:Exchange Link`,
    inputType: 'text',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
];
